import { createSelector } from 'reselect';
import { KEY } from './';
import { GlobalState } from 'store/types';

const getVenuesState = (state: GlobalState) => state[KEY];

const selectVenues = createSelector(getVenuesState, (venues) => venues.venues);

const selectAction = createSelector(getVenuesState, (venues) => venues.action);

export const selectors = {
  selectVenues,
  selectAction
};
